var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleValet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 1.16669C3.78008 1.16669 1.16675 3.78002 1.16675 7.00002C1.16675 10.22 3.78008 12.8334 7.00008 12.8334C10.2201 12.8334 12.8334 10.22 12.8334 7.00002C12.8334 3.78002 10.2201 1.16669 7.00008 1.16669ZM7.00008 11.6667C4.42758 11.6667 2.33341 9.57252 2.33341 7.00002C2.33341 4.42752 4.42758 2.33335 7.00008 2.33335C9.57258 2.33335 11.6667 4.42752 11.6667 7.00002C11.6667 9.57252 9.57258 11.6667 7.00008 11.6667ZM9.67758 4.42169L5.83341 8.26585L4.32258 6.76085L3.50008 7.58335L5.83341 9.91669L10.5001 5.25002L9.67758 4.42169Z",
    fill: "#003844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleValet);
export default __webpack_public_path__ + "static/media/check_circle_valet.872a12842327dff8d8ffed6a80bad8fa.svg";
export { ForwardRef as ReactComponent };